import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { Config } from '@/config';
import {
  errorModalTextRecoil,
  completeModalRecoil,
  deleteModalRecoil,
  facilitiesModifyModalRecoil,
  imgDetailModalRecoil,
} from '@/atom/ModalAtom';
import { facilitiesDetailRecoil } from '@/atom/FacilitiesAtom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import TitleTextBox from '@/component/TitleTextBox';
import Pagenation from '@/component/Pagenation';
import SearchBtn from '@/component/SearchBtn';
import DeleteModal from '@/modal/DeleteModal';
import LabelType1 from '@/component/LabelType1';
import {
  Map,
  MapMarker,
  MapTypeControl,
  ZoomControl,
} from 'react-kakao-maps-sdk';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { FacilityApi } from '@/sdk/FacilityApi';
import ImgModal from '@/modal/ImgModal';
import { DeleteFacilityDtoTx } from '@/sdk/data-contracts';
import FacilitiesModifyModal from '@/modal/FacilitiesModifyModal';
import InstallationDevice from './facilities/InstallationDevice';
import EventList from './facilities/EventList';
import LocationInfor from './facilities/LocationInfor';
import InspectionLog from './facilities/InspectionLog';

declare global {
  interface Window {
    kakao: any;
  }
}

const FacilitiesDetail = () => {
  const { id } = useParams<{ id: string }>();
  const facilityApi = new FacilityApi({ baseURL: Config.API_URL });
  const navigate = useNavigate();

  const setErrorModalText = useSetRecoilState(errorModalTextRecoil);
  const setCompleteModalState = useSetRecoilState(completeModalRecoil);
  const [facilitiesModifyModalState, setFacilitiesModifyModalState] =
    useRecoilState(facilitiesModifyModalRecoil);
  const [imgDetailModalState, setImgDetailModalState] =
    useRecoilState(imgDetailModalRecoil);
  const [deleteModalState, setDeleteModalState] =
    useRecoilState(deleteModalRecoil);
  const [facilitiesDetailState, setFacilitiesDetailState] = useRecoilState(
    facilitiesDetailRecoil,
  );

  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [sortBy, setSortBy] = useState<string>('createdAt');
  const [order, setOrder] = useState<string>('desc');
  const [center, setCenter] = useState({ lat: 33.450701, lng: 126.570667 });
  const [checkItems, setCheckItems] = useState<number[]>([Number(id)]);
  const [tab1ActiveIndex, setTab1ActiveIndex] = useState<number>(0);

  const allCheckBtnRef = useRef<HTMLInputElement>(null);

  const geocodeAddress = (address: string) => {
    const kakao = window.kakao;
    if (!kakao || !kakao.maps) {
      console.error('Kakao Maps API가 로드되지 않았습니다.');
      return;
    }
    const geocoder = new kakao.maps.services.Geocoder();
    geocoder.addressSearch(address, (result: any, status: any) => {
      if (status === kakao.maps.services.Status.OK) {
        const newCenter = {
          lat: parseFloat(result[0].y),
          lng: parseFloat(result[0].x),
        };
        setCenter(newCenter);
      } else {
        console.error('주소 검색에 실패했습니다.');
      }
    });
  };

  const fetchFacilitiesDetail = async () => {
    try {
      const { data } = await facilityApi.facilityControllerGetFacility(
        Number(id),
        {
          headers: {
            Authorization: `Bearer ${String(sessionStorage.getItem('accessToken'))}`,
            'Content-Type': 'application/json',
          },
        },
      );
      setFacilitiesDetailState(data);
    } catch (err: any) {}
  };

  const handleSelectDeleteNumCheck = () => {
    setDeleteModalState(true);
  };

  const handleSelectDelete = async () => {
    const dto: DeleteFacilityDtoTx = {
      ids: checkItems,
    };

    try {
      await facilityApi.facilityControllerDeleteFacility(dto, {
        headers: {
          Authorization: `Bearer ${String(sessionStorage.getItem('accessToken'))}`,
          'Content-Type': 'application/json',
        },
      });
      navigate('/facilities');
    } catch (err: any) {}
  };

  const openAndSavePDF = () => {
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;

    const newWindow = window.open(
      'http://localhost:3000/facilitiesreport',
      '_blank',
      `width=${screenWidth},height=${screenHeight}`,
    );

    if (newWindow) {
      newWindow.onload = async () => {
        try {
          // await new Promise((resolve) => setTimeout(resolve, 2000));

          const pdfContent =
            newWindow.document.querySelectorAll('.section-box');
          const pdf = new jsPDF('p', 'mm', 'a4');

          for (let i = 0; i < pdfContent.length; i++) {
            const section = pdfContent[i];
            const canvas = await html2canvas(section as HTMLElement);
            const imgData = canvas.toDataURL('image/png');
            const imgWidth = 190;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            if (i > 0) {
              pdf.addPage();
            }

            pdf.addImage(imgData, 'PNG', 10, 10, imgWidth, imgHeight);
          }

          pdf.save('facilities.pdf');
          newWindow.close();
        } catch (error) {
          console.error('PDF 생성 중 오류가 발생했습니다:', error);
          newWindow.close();
        }
      };
    }
  };

  useEffect(() => {
    fetchFacilitiesDetail();
  }, [limit, offset]);

  return (
    <>
      <CntBox1>
        <div className="flex aic jcsb">
          <TitleTextBox text="시설물 상세정보" />
          <BS.BtnBox1>
            <BS.Btn1Type1 type="button" onClick={() => navigate('/facilities')}>
              목록
            </BS.Btn1Type1>
            <BS.Btn1Type1
              type="button"
              onClick={() => setFacilitiesModifyModalState(true)}
            >
              수정
            </BS.Btn1Type1>
            <BS.Btn1Type2 type="button" onClick={handleSelectDeleteNumCheck}>
              삭제
            </BS.Btn1Type2>
          </BS.BtnBox1>
        </div>
        <InforWrap>
          <InforBox>
            <h1>시설물 기본정보</h1>
            <div className="text-wrap">
              <ul className="text-box">
                <li>
                  <h2 style={{ minWidth: 90 }}>시설 번호</h2>
                  <p>{facilitiesDetailState?.number}</p>
                </li>
                <li>
                  <h2 style={{ minWidth: 90 }}>건물 용도</h2>
                  <p>{facilitiesDetailState?.purpose}</p>
                </li>
                <li>
                  <h2 style={{ minWidth: 90 }}>건물 상태</h2>
                  <p>{facilitiesDetailState?.condition}</p>
                </li>
                <li>
                  <h2 style={{ minWidth: 90 }}>상세동</h2>
                  <p>{facilitiesDetailState?.address}</p>
                </li>
                <li>
                  <h2 style={{ minWidth: 90 }}>메모</h2>
                  <p>{facilitiesDetailState?.memo}</p>
                </li>
              </ul>
              <ul className="text-box">
                <li>
                  <h2 style={{ minWidth: 90 }}>시설명</h2>
                  <p>{facilitiesDetailState?.name}</p>
                </li>
                <li>
                  <h2 style={{ minWidth: 90 }}>구조</h2>
                  <p>{facilitiesDetailState?.structure}</p>
                </li>
                <li>
                  <h2 style={{ minWidth: 90 }}>사이트</h2>
                  <p>{facilitiesDetailState?.siteName}</p>
                </li>
                <li>
                  <h2 style={{ minWidth: 90 }}>첨부파일</h2>
                  <p>
                    <button
                      className="click-btn"
                      onClick={() => setImgDetailModalState(true)}
                    >
                      {facilitiesDetailState?.fileName}
                    </button>
                  </p>
                </li>
              </ul>
            </div>
          </InforBox>
          <InforBox>
            <h1>시설 책임 담당자 정보</h1>
            <div className="text-wrap">
              <ul className="text-box">
                <li>
                  <h2 style={{ minWidth: 123 }}>부서</h2>
                  <p>{facilitiesDetailState?.department}</p>
                </li>
                <li>
                  <h2 style={{ minWidth: 123 }}>성명</h2>
                  <p>{facilitiesDetailState?.facilityManagerName}</p>
                </li>
                <li>
                  <h2 style={{ minWidth: 123 }}>연락처</h2>
                  <p>{facilitiesDetailState?.phone}</p>
                </li>
                <li>
                  <h2 style={{ minWidth: 123 }}>SMS 수신 여부</h2>
                  <p>{facilitiesDetailState?.isSmsReception ? '여' : '부'}</p>
                </li>
                <li>
                  <h2 style={{ minWidth: 123 }}>수신 시간</h2>
                  <p>{facilitiesDetailState?.receptionTime}</p>
                </li>
              </ul>
              <ul className="text-box">
                <li>
                  <h2 style={{ minWidth: 118 }}>통신이상 알림</h2>
                  <p>
                    {facilitiesDetailState?.isCommunicationError ? '여' : '부'}
                  </p>
                </li>
                <li>
                  <h2 style={{ minWidth: 118 }}>센서이상 알림</h2>
                  <p>{facilitiesDetailState?.isSensorError ? '여' : '부'}</p>
                </li>
              </ul>
            </div>
          </InforBox>
        </InforWrap>
      </CntBox1>
      <CntBox2>
        <CS.TabMenuType1Mini>
          <button
            type="button"
            className={tab1ActiveIndex === 0 ? 'active' : ''}
            onClick={() => setTab1ActiveIndex(0)}
          >
            설치 디바이스
          </button>
          <button
            type="button"
            className={tab1ActiveIndex === 1 ? 'active' : ''}
            onClick={() => setTab1ActiveIndex(1)}
          >
            이벤트 발생 내역
          </button>
          <button
            type="button"
            className={tab1ActiveIndex === 2 ? 'active' : ''}
            onClick={() => setTab1ActiveIndex(2)}
          >
            위치 정보
          </button>
          <button
            type="button"
            className={tab1ActiveIndex === 3 ? 'active' : ''}
            onClick={() => setTab1ActiveIndex(3)}
          >
            점검 일지
          </button>
        </CS.TabMenuType1Mini>
        {tab1ActiveIndex === 0 && <InstallationDevice />}
        {tab1ActiveIndex === 1 && <EventList />}
        {tab1ActiveIndex === 2 && <LocationInfor />}
        {tab1ActiveIndex === 3 && <InspectionLog />}
      </CntBox2>
      {imgDetailModalState && (
        <ImgModal fileUrl={String(facilitiesDetailState?.fileUrl)} />
      )}
      {facilitiesModifyModalState && <FacilitiesModifyModal id={String(id)} />}
      {deleteModalState && <DeleteModal onConfirm={handleSelectDelete} />}
    </>
  );
};

export default FacilitiesDetail;

export const CntBox1 = styled(CS.CntBoxType1)`
  width: 100%;
`;

export const CntBox2 = styled(CS.CntBoxType1)`
  width: 100%;
  margin-top: 20px;
`;

export const InforWrap = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
  margin-top: 16px;
`;

export const InforBox = styled(CS.CntBoxType2)`
  width: calc(50% - 10px);
`;

export const SearchOptionBox = styled(CS.SearchOptionBox)`
  width: 100%;
  margin-top: 20px;
`;

export const InputWrap = styled.div`
  gap: 8px;
  display: flex;
  flex-direction: column;
`;

export const InputArea = styled.div`
  gap: 8px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  > h2 {
    color: #555;
    font-size: 14px;
  }
`;

export const TabCntBox = styled.div`
  width: 100%;
  margin-top: 20px;
`;

export const TableOpitonBox = styled(CS.TableOpitonBox)`
  width: 100%;
  margin-top: 0;
`;

export const TableBox = styled(CS.TableType1)`
  width: 100%;
  margin-top: 16px;
  margin-bottom: 32px;
`;

export const MapBox = styled.div`
  width: 100%;
  height: 400px;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
`;

export const MapModal = styled.div`
  position: absolute;
  z-index: 10;
  top: 50%;
  left: 60%;
  transform: translate(-50%, -50%);
  width: 136px;
  border-radius: 4px;
  box-sizing: border-box;
  border: 1px solid #d9d9d9;
  box-shadow: 4px 4px 12px 0px rgba(255, 255, 255, 0.25);
  overflow: hidden;
  > .title-box {
    box-sizing: border-box;
    padding: 8px 12px;
    background: #e9e8e8;
    font-size: 16px;
    font-weight: 500;
  }
  > .text-box {
    box-sizing: border-box;
    padding: 12px;
    background: #fff;
    > .state-box {
      display: flex;
      align-items: center;
      gap: 8px;
      > .text {
        font-size: 15px;
      }
      > .line {
        width: 1px;
        height: 10px;
        background: #d9d9d9;
      }
    }
    > .date {
      margin-top: 6px;
      font-size: 12px;
      font-weight: 300;
      color: #777;
    }
    > button {
      margin-top: 8px;
      font-size: 14px;
      color: #3c8deb;
    }
  }
`;

export const MapTextModal = styled.div`
  position: absolute;
  z-index: 10;
  top: 50%;
  left: 70%;
  transform: translate(-50%, -50%);
  border-radius: 4px;
  box-sizing: border-box;
  border: 1px solid #d9d9d9;
  padding: 10px 16px;
  box-shadow: 4px 4px 12px 0px rgba(255, 255, 255, 0.25);
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  > p {
    font-size: 15px;
    white-space: nowrap;
  }
  > button {
    width: 10px;
    min-width: 10px;
  }
`;
